import { jsx as _jsx } from "react/jsx-runtime";
import { ThorView } from '@aviv-dxp/react-thor';
import { useAuthentication } from '@aviv-unified-frontend/runtime/authentication';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { useShortBrand } from '@/contexts/brandConfiguration/hooks';
import { APP_ENV, ENV_LIVE, ENV_PREVIEW } from '@/utils/constants';
import { INITIATIVE } from './constants';
import { cid, parseJwt } from './utils';
// TODO: check with tracking team
export const TrackingView = () => {
    const shortBrand = useShortBrand();
    const { state, unsafe_accessToken } = useAuthentication();
    const { language } = useLocale();
    const isConnected = state === 'authenticated';
    const accessToken = unsafe_accessToken ? parseJwt(unsafe_accessToken) : '';
    const viewProps = {
        av_category: 'nutzungsdauer',
        av_platform: 'web',
        av_environment: APP_ENV === ENV_LIVE
            ? 'prod'
            : APP_ENV === ENV_PREVIEW
                ? 'preprod'
                : 'staging',
        av_site: shortBrand,
        av_language: language,
        av_user: {
            status: isConnected ? 'logged' : 'unlogged',
            ...(isConnected
                ? { uid: accessToken.avivUserId, cid: cid() }
                : { cid: cid() }),
        },
        av_pagetitle: 'nutzungsdauer_landing',
        av_initiative: INITIATIVE,
    };
    return typeof window !== 'undefined' && _jsx(ThorView, { viewProps: viewProps });
};
